// extracted by mini-css-extract-plugin
export default {"container":"StockManagement_container__qnAaJ"};